<template>
  <f7-page @page:beforein="refreshUserStores">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>AI 服務生</f7-nav-title>
    </f7-navbar>

    <f7-block v-if="displayName">使用者：{{ displayName }}</f7-block>
    <f7-list v-if="stores">
      <f7-list-item title="店家列表" group-title />
      <f7-list-item
        v-for="(store, index) in stores"
        :key="`index-stores-${index}`"
        :title="`${store.name} ${store.branch === null ? '' : `-${store.branch}`} (${store.id})`"
        @click="setStore(store.id)"
        class="ripple"
        style="overflow: hidden;">
        <font-awesome-icon v-if="storeId === store.id" slot="after" :icon="['far', 'dot-circle']" style="color: #4caf50;" />
      </f7-list-item>
      <f7-button v-if="hasCreateStorePermission" raised fill href="/create-new-store" style="margin: 20px;">建立新店家</f7-button>
    </f7-list>
    <div v-else>載入中，請稍等...</div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  dependencies: ['permissionType'],
  computed: {
    ...mapState('userModule', ['uid', 'displayName', 'stores', 'permissions']),
    ...mapGetters(['storeId']),
    hasCreateStorePermission () {
      return this.permissions['*'] && this.permissions['*'][this.permissionType.createStore]
    }
  },
  methods: {
    ...mapActions(['setStore']),
    ...mapActions('userModule', ['getAllUserStores']),
    refreshUserStores () {
      if (this.uid) {
        this.getAllUserStores(this.uid)
      }
    }
  }
}
</script>
